/* Move the open search modal out of the header stacking/containing block.
   Keeps Shopify's native details-modal and predictive-search intact. */
(() => {
  if (window.__kavedanSearchPortalReady) return;
  window.__kavedanSearchPortalReady = true;
  const desktop = window.matchMedia('(min-width: 990px)');
  function setup() {
    document.querySelectorAll('details-modal.header__search').forEach((host) => {
      if (host.dataset.kavedanPortalInit) return;
      host.dataset.kavedanPortalInit = 'true';
      const details = host.querySelector('details');
      if (!details) return;
      const marker = document.createComment('Kavedan search portal location');
      host.parentNode.insertBefore(marker, host);
      const relocate = () => {
        if (details.open && desktop.matches) {
          if (host.parentNode !== document.body) document.body.appendChild(host);
          host.classList.add('kavedan-search-portalled');
        } else {
          host.classList.remove('kavedan-search-portalled');
          if (marker.parentNode && host.parentNode !== marker.parentNode)
            marker.parentNode.insertBefore(host, marker.nextSibling);
        }
      };
      const observer = new MutationObserver(relocate);
      observer.observe(details, { attributes: true, attributeFilter: ['open'] });
      desktop.addEventListener('change', relocate);
      relocate();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup);
  else setup();
  document.addEventListener('shopify:section:load', setup);
})();
